/**
 * CabinPicker — popover content for the CABIN pill.
 *
 * Simple radio-style option list. The display label for each option is the
 * title-case form (`'Premium Economy'`) while the stored value is the
 * canonical hyphenated form (`'premium-economy'`).
 */

import { Check } from 'lucide-react'
import type { Cabin } from '@/lib/search/types'
import { CABIN_OPTIONS } from '../format'

interface CabinPickerProps {
  value: Cabin
  onChange: (next: Cabin) => void
}

export function CabinPicker({ value, onChange }: CabinPickerProps) {
  return (
    <div className="sc-picker" data-cabin-picker role="radiogroup" aria-label="Cabin class">
      <div className="sc-picker-title">Cabin</div>
      {CABIN_OPTIONS.map((option) => {
        const selected = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className="sc-cabin-option"
            data-selected={selected}
            onClick={() => onChange(option.value)}
          >
            <Check
              className="sc-pill-icon"
              style={{ opacity: selected ? 1 : 0 }}
              aria-hidden="true"
            />
            <span>{option.label}</span>
          </button>
        )
      })}
    </div>
  )
}
